/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export const YouTubePlayButton = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="69px"
    height="69px"
    viewBox={"0 0 69 69"}
    xmlSpace="preserve"
  >
    <defs></defs>
    <g
      style={{
        stroke: "none",
        strokeWidth: "0",
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: "10",
        fill: "none",
        fillRule: "nonzero",
        opacity: "1",
      }}
      transform={"translate(1.4065934065934016 0) scale(0.75740 0.75740)"}
    >
      <path
        d="M 88.119 23.338 c -1.035 -3.872 -4.085 -6.922 -7.957 -7.957 C 73.144 13.5 45 13.5 45 13.5 s -28.144 0 -35.162 1.881 c -3.872 1.035 -6.922 4.085 -7.957 7.957 C 0 30.356 0 45 0 45 s 0 14.644 1.881 21.662 c 1.035 3.872 4.085 6.922 7.957 7.957 C 16.856 76.5 45 76.5 45 76.5 s 28.144 0 35.162 -1.881 c 3.872 -1.035 6.922 -4.085 7.957 -7.957 C 90 59.644 90 45 90 45 S 90 30.356 88.119 23.338 z"
        style={{
          stroke: "none",
          strokeWidth: "1",
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: "10",
          fill: "rgb(20,20,20)",
          fillRule: "nonzero",
          opacity: 0.7,
        }}
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
      <polygon
        points="36,58.5 59.38,45 36,31.5 "
        style={{
          stroke: "none",
          strokeWidth: "1",
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: "10",
          fill: "rgb(255,255,255)",
          fillRule: "nonzero",
          opacity: "1",
        }}
        transform="  matrix(1 0 0 1 0 0) "
      />
    </g>
  </svg>
);

// export const ShareButton = () => (
//   <svg height="100%" version="1.1" viewBox="0 0 36 36" width="100%">
//     <use className="ytp-svg-shadow" xlinkHref="#ytp-id-56"></use>
//     <path
//       className="ytp-svg-fill"
//       d="m 20.20,14.19 0,-4.45 7.79,7.79 -7.79,7.79 0,-4.56 C 16.27,20.69 12.10,21.81 9.34,24.76 8.80,25.13 7.60,27.29 8.12,25.65 9.08,21.32 11.80,17.18 15.98,15.38 c 1.33,-0.60 2.76,-0.98 4.21,-1.19 z"
//       id="ytp-id-56"
//       fill="#DDD"
//     ></path>
//   </svg>
// );

// export const VerticalDots = () => (
//   <svg height="100%" viewBox="-5 -5 36 36" width="100%">
//     <path
//       d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
//       fill="#DDD"
//     ></path>
//   </svg>
// );
